import Svg, { Path } from 'react-native-svg'

export const RupeeTabIcon = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        fillOpacity={1}
        d="M17 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3ZM9.5 6h5a1 1 0 1 1 0 2h-.18a3 3 0 0 1-.93 3.33l1.56.78A1 1 0 0 1 14.5 14a.93.93 0 0 1-.45-.11l-4-2A1 1 0 0 1 10.5 10h1a1 1 0 1 0 0-2h-2a1 1 0 0 1 0-2ZM15 19H9a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2Z"
      />
    </Svg>
  )
}
